import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook } from "lucide-react";
import { LOGO } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src={LOGO} alt="Being Fit For You" className="h-16 w-16 rounded-xl bg-black object-contain p-1.5 mb-6" />
            <div className="font-display text-5xl md:text-6xl uppercase leading-[0.9] tracking-tight">
              Fitness for<br />every body.<br /><span className="text-primary">Every goal.</span>
            </div>
            <Link to="/assessment" data-testid="footer-cta"
              className="inline-block mt-8 bg-primary text-primary-foreground px-8 py-4 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.03] transition-transform">
              Take the Free Assessment
            </Link>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-bold mb-5">Explore</p>
            <ul className="space-y-3 text-muted-foreground text-sm">
              <li><Link to="/programs" className="hover:text-foreground transition-colors">Programs</Link></li>
              <li><Link to="/videos" className="hover:text-foreground transition-colors">Video Library</Link></li>
              <li><Link to="/blog" className="hover:text-foreground transition-colors">Journal & Myths</Link></li>
              <li><Link to="/about" className="hover:text-foreground transition-colors">About</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-bold mb-5">Connect</p>
            <div className="flex gap-3">
              {[{ Icon: Instagram, href: "https://instagram.com/beingfitforu_personal_training" }, { Icon: Youtube, href: "#" }, { Icon: Facebook, href: "#" }].map(({ Icon, href }, i) => (
                <a key={i} href={href} target={href === "#" ? undefined : "_blank"} rel="noreferrer" aria-label="social" className="grid place-items-center w-11 h-11 border border-border rounded-full hover:border-primary hover:text-primary transition-colors"><Icon size={18} /></a>
              ))}
            </div>
            <p className="text-sm text-muted-foreground mt-5">abhishar2010@gmail.com</p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-3 text-xs text-muted-foreground uppercase tracking-wider">
          <span>&copy; {new Date().getFullYear()} BeingFitForYou &middot; @beingfitforyou</span>
          <Link to="/login" className="hover:text-foreground transition-colors">Coach / Admin Login</Link>
        </div>
      </div>
    </footer>
  );
}
